import React, { Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Routes as routes } from 'routes';
import { useApp } from 'context/AppContext';
import { Loader } from 'components/Loader/Loader';

const Pages = () => {
    const { isInitializing } = useApp();

    if (isInitializing) {
        return <Loader />;
    }

    return (
        <Suspense fallback="">
            <Routes>
                { routes.public.map(
                    ({ path, page }) => (
                        <Route key={path} path={path} element={page} />),
                ) }
                { routes.private.map(
                    ({ path, page }) => (
                        <Route key={path} path={path} element={page} />),
                ) }
            </Routes>
        </Suspense>
    );
};

export default Pages;
